import React from 'react';
import { useScrollReveal } from '../hooks/useScrollReveal';
import { Link } from 'react-router-dom';
import { Card, CardContent } from './ui/card';
import { Avatar, AvatarImage, AvatarFallback } from './ui/avatar';
import { Button } from './ui/button';
import { User } from 'lucide-react';
import { useTranslation } from 'react-i18next';

const TeamSection = () => {
  const { t } = useTranslation();
  const sectionRef = useScrollReveal();

  return (
    <section id="team" className="py-20 px-4 bg-white" ref={sectionRef}>
      <div className="container mx-auto max-w-6xl">
        <h2 className="text-3xl md:text-4xl font-bold text-slate-900 mb-4 text-center scroll-reveal">
          {t('team.title')}
        </h2>
        <div className="w-20 h-1 mx-auto mb-12 scroll-reveal" style={{ backgroundColor: 'var(--medical-primary)', animationDelay: '0.1s' }}></div>

        <div className="max-w-2xl mx-auto">
          <Card 
            className="card-hover scroll-reveal-scale border-0 shadow-xl overflow-hidden" 
            style={{ 
              animationDelay: '0.2s',
              boxShadow: '0 10px 40px rgba(5, 56, 39, 0.12)'
            }}
          >
            <div 
              className="h-2 w-full"
              style={{ 
                background: 'linear-gradient(90deg, #053827 0%, #10b981 100%)'
              }}
            />
            <CardContent className="pt-8">
              <div className="flex flex-col md:flex-row items-center gap-6">
                <Avatar className="w-32 h-32 border-4 shadow-2xl" style={{ borderColor: 'var(--medical-primary)' }} data-testid="team-doctor-photo">
                  <AvatarImage src="/gallery-images/doctor.jpg" alt="Dr. Nikhil Tonge" className="object-cover" />
                  <AvatarFallback className="text-white text-4xl font-bold" style={{ backgroundColor: 'var(--medical-primary)' }}>
                    NT
                  </AvatarFallback>
                </Avatar>
                
                <div className="flex-1 text-center md:text-left">
                  <h3 className="text-2xl font-bold text-slate-900 mb-2">
                    {t('team.name')}
                  </h3>
                  <p className="text-lg font-semibold mb-2" style={{ color: 'var(--medical-accent)' }}>
                    {t('team.degree')}
                  </p>
                  <p className="text-slate-600 mb-4">
                    {t('team.specialization')}
                  </p>
                  <p className="text-sm text-slate-600 mb-4">
                    {t('team.expertise')}
                  </p>
                  <Link to="/doctor-profile">
                    <Button
                      variant="outline"
                      size="sm"
                      className="mt-2 border-2 transition-all duration-300 hover:scale-105 hover:shadow-md"
                      style={{ borderColor: 'var(--medical-primary)', color: 'var(--medical-primary)' }}
                      onMouseEnter={(e) => {
                        e.currentTarget.style.backgroundColor = '#f0fdf4';
                        e.currentTarget.style.borderColor = '#064d35';
                      }}
                      onMouseLeave={(e) => {
                        e.currentTarget.style.backgroundColor = '';
                        e.currentTarget.style.borderColor = 'var(--medical-primary)';
                      }}
                    >
                      <User className="mr-2" size={16} />
                      {t('team.viewProfile')}
                    </Button>
                  </Link>
                </div>
              </div>
            </CardContent>
          </Card>
        </div>
      </div>
    </section>
  );
};

export default TeamSection;